export default __webpack_public_path__ + "static/media/alba-festival-history-2022.74c954f6.jpg";